@use '~/theme/theme' as *;

.mainLabel {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: color(gray-800);
}

.success {
  color: color(green-800);
}

.error {
  color: color(lobster-800);
}

.secondaryLabel {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
